import styled from 'styled-components';
import media from '../../../styles/media.style';
import { PAGE_WIDTH, MOBILE_PADDING } from '../../../styles/variables.style';

export const Section = styled.section`
  background-color: ${({ color }) => (color ? '#333' : 'white')};
  margin: auto;
  max-width: ${PAGE_WIDTH}px;
  padding: 20px 0;

  ${media.tabletL`
    display: flex;
    flex-direction: ${({ index }) => (index % 2 === 0 ? 'row-reverse' : 'row')};
  `};
`;

export const TextContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: ${MOBILE_PADDING}px;

  ${media.tabletL`
    padding: 60px 80px;
    width: 50%;
  `};
`;

export const TextContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
  width: 400px;
`;

export const Title = styled.div`
  color: ${({ color }) => (color ? 'white' : 'black')};
  font-size: 30px;
  letter-spacing: 1px;
  text-transform: uppercase;
  max-width: 400px;
  width: 100%;

  ${media.tabletL`
    font-size: 44px;
  `};
`;

export const Description = styled.div`
  color: ${({ color }) => (color ? 'white' : 'black')};
  font-size: 16px;
  line-height: 1.4;
  margin-top: 25px;
  max-width: 400px;
  width: 100%;

  ${media.tabletL`
    font-size: 18px;
  `};
`;

export const ImageContainer = styled.div`
  padding: ${MOBILE_PADDING}px;

  ${media.tabletL`
    padding: 60px 80px;
    width: 50%;
  `};
`;

export const ButtonContainer = styled.div`
  margin: 50px auto 0;
`;

export const Button = styled.div`
  background-color: black;
  color: white;
  padding: 30px 100px;
`;



// WEBPACK FOOTER //
// ./src/pages/EducationPage/EducationSection/EducationSection.style.js